import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { AutoCompleteProjectComponent } from './auto-complete-projects/auto-complete-projects.component';
import { AutoCompleteComponent } from './auto-complete/auto-complete.component';
import { AutoCompleteMoteChildrenComponent } from './auto-complete-mote-children/auto-complete-mote-children.component';
import { AutoCompleteMotesComponent } from './auto-complete-motes/auto-complete-motes.component';
import { AutoCompleteVenuesComponent } from './auto-complete-venues/auto-complete-venues.component';

import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
    declarations: [
        AutoCompleteComponent,
        AutoCompleteMoteChildrenComponent,
        AutoCompleteMotesComponent,
        AutoCompleteProjectComponent,
        AutoCompleteVenuesComponent],
    imports: [
        CommonModule,
        FormsModule,
        ScrollingModule,
        SvgIconModule
    ],
    exports: [
        AutoCompleteComponent,
        AutoCompleteMoteChildrenComponent,
        AutoCompleteMotesComponent,
        AutoCompleteProjectComponent,
        AutoCompleteVenuesComponent
    ]
})
export class AutoCompleteModule { }
